import React, { useContext } from 'react';

import { ConditionalWrapper } from '@/components/ConditionalWrapper';
import { UserSearchContext } from '@/core/users/UserManagement/UserSearchContext';
import { ReactComponent as ArrowDown } from '@/icons/arrow_down.svg';
import { ReactComponent as ArrowUp } from '@/icons/arrow_up.svg';

export const COLUMNS = [
  {
    label: 'Name',
    sortKey: 'display_name',
    width: 450,
  },
  {
    label: 'Type',
    width: 250,
  },
  {
    label: 'Product Access',
  },
  {
    // Action menu
    label: '',
    width: 70,
  },
];

export function UserListHeader () {
  const { canSort, setSort, sort } = useContext(UserSearchContext);

  const handleSort = (sortKey: string) => {
    if (sortKey === sort) {
      setSort(`-${sort}`);
    } else {
      setSort(sortKey);
    }
  };

  return (
    <tr>
      {COLUMNS.map(({ label, sortKey, width }) => (
        <th key={label} className="px-0 py-0 text-sm text-left" style={{ width }}>
          <ConditionalWrapper
            condition={!!sortKey && canSort}
            wrapper={(children) => (
              <button className="w-full" onClick={() => handleSort(sortKey!)}>
                {children}
              </button>
            )}
          >
            <div className="flex items-center w-full px-6 py-4">
              <span className="font-bold">
                {label}
              </span>
              {(sortKey && canSort) && (
                <span className="pl-3">
                  {sort?.indexOf(sortKey) !== -1 ? (
                    <>
                      {sort === sortKey ? (
                        <ArrowUp className="w-2 h-2" />
                      ) : (
                        <ArrowDown className="w-2 h-2" />
                      )}
                    </>
                  ) : (
                    <ArrowUp className="w-2 h-2 text-gray-300" />
                  )}
                </span>
              )}
            </div>
          </ConditionalWrapper>
        </th>
      ))}
    </tr>
  );
}
